import { ComponentSingleStyleConfig } from '@chakra-ui/react';

export enum InputVariant {
  OUTLINE = 'outline',
  OUTLINE_DARK = 'outline_dark',
}

const Input: ComponentSingleStyleConfig = {
  baseStyle: {
    borderColor: 'gray.400',
    focusBorderColor: 'secondary',
    field: {
      color: 'fontColor',
    },
  },

  variants: {
    [InputVariant.OUTLINE]: {
      focusBorderColor: 'secondary',
      field: {
        borderColor: 'gray.400',
        _hover: {
          borderColor: 'gray.400',
        },
      },
    },
    [InputVariant.OUTLINE_DARK]: {
      field: {
        borderWidth: '1px',
        borderColor: 'gray.400',
        _hover: {
          borderColor: 'gray.400',
        },
        _focus: {
          borderColor: 'dark',
        },
        _invalid: {
          borderColor: 'danger.600',
        },
        _disabled: {
          borderColor: 'gray.300',
          color: 'gray.400',
        },
      },
    },
  },

  defaultProps: {
    variant: InputVariant.OUTLINE,
    focusBorderColor: 'secondary',
  },
};

export default Input;
